module.exports = __webpack_public_path__ + "fonts/Inter-600-latin-ext62.2685934.woff2";